import { render, staticRenderFns } from "./collectionAgreement.vue?vue&type=template&id=785e94b6&scoped=true"
import script from "./collectionAgreement.vue?vue&type=script&lang=js"
export * from "./collectionAgreement.vue?vue&type=script&lang=js"
import style0 from "./collectionAgreement.vue?vue&type=style&index=0&id=785e94b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e94b6",
  null
  
)

export default component.exports